import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=40e4a420&scoped=true"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js"
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=40e4a420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4a420",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AnimatedLogo.vue
// module id = 31
// module chunks = 0